"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var helper_1 = require("../helper");
/**
 * An implementation of {@link DataService} to work with Apollo's services which return JSON-based data.
 * @class
 * @implements {DataService}
 */
var HttpDataService = /** @class */ (function () {
    function HttpDataService(_http, _cookieService) {
        this._http = _http;
        this._cookieService = _cookieService;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(_http);
    }
    HttpDataService_1 = HttpDataService;
    /**
     * Method expected to extract appropriate data from the response in accordance to HTTP response's structure.
     * @param {Object} body - The response object.
     * @returns {any} Data extracted from the response.
     * @private
     * @static
     */
    HttpDataService._extractResponseData = function (body) {
        return body || {};
    };
    HttpDataService.prototype.load = function (url, searchParams) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(url);
        var headers = new http_1.HttpHeaders({
            'Content-Type': 'application/json',
        });
        var params = new http_1.HttpParams();
        if (Array.isArray(searchParams)) {
            searchParams.forEach(function (searchParam) {
                var value = typeof searchParam.getValue() !== 'object'
                    ? searchParam.getValue()
                    : JSON.stringify(searchParam.getValue());
                if (searchParam.getValue() instanceof Array) {
                    var arrayValues = searchParam.getValue();
                    arrayValues.forEach(function (item) {
                        return (params = params.append(searchParam.getName(), item));
                    });
                }
                else {
                    params = params.set(searchParam.getName(), value);
                }
            });
        }
        var options = { headers: headers, params: params };
        return this._http
            .get(url, options)
            .pipe(operators_1.map(HttpDataService_1._extractResponseData), operators_1.catchError(helper_1.handleResponseError));
    };
    HttpDataService.prototype.add = function (url, data, searchParams) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(url);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(data);
        var body = JSON.stringify(data);
        var params = new http_1.HttpParams();
        if (Array.isArray(searchParams)) {
            searchParams.forEach(function (searchParam) {
                var value = typeof searchParam.getValue() !== 'object'
                    ? searchParam.getValue()
                    : JSON.stringify(searchParam.getValue());
                params = params.set(searchParam.getName(), value);
            });
        }
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
        var options = { headers: headers, params: params };
        return this._http
            .post(url, body, options)
            .pipe(operators_1.map(HttpDataService_1._extractResponseData), operators_1.catchError(helper_1.handleResponseError));
    };
    HttpDataService.prototype.update = function (url, data, searchParams) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(url);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(data);
        var body = JSON.stringify(data);
        var params = new http_1.HttpParams();
        if (Array.isArray(searchParams)) {
            searchParams.forEach(function (searchParam) {
                var value = typeof searchParam.getValue() !== 'object'
                    ? searchParam.getValue()
                    : JSON.stringify(searchParam.getValue());
                params = params.set(searchParam.getName(), value);
            });
        }
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
        var options = { headers: headers, params: params };
        return this._http
            .put(url, body, options)
            .pipe(operators_1.map(HttpDataService_1._extractResponseData), operators_1.catchError(helper_1.handleResponseError));
    };
    HttpDataService.prototype.delete = function (url, searchParams) {
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(url);
        var params = new http_1.HttpParams();
        if (Array.isArray(searchParams)) {
            searchParams.forEach(function (searchParam) {
                var value = typeof searchParam.getValue() !== 'object'
                    ? searchParam.getValue()
                    : JSON.stringify(searchParam.getValue());
                params = params.set(searchParam.getName(), value);
            });
        }
        var headers = new http_1.HttpHeaders({ 'Content-Type': 'application/json' });
        var options = { headers: headers, params: params };
        return this._http
            .delete(url, options)
            .pipe(operators_1.catchError(helper_1.handleResponseError));
    };
    HttpDataService.prototype.upload = function (url, file, data) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(url);
        idm_common_util_frontend_1.PreconditionCheck.notNullOrUndefined(file);
        return Observable_1.Observable.create(function (observer) {
            var formData = new FormData();
            var xhr = new XMLHttpRequest();
            formData.append('file', file, file.name);
            formData.append('data', JSON.stringify(data));
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        observer.next(JSON.parse(xhr.response));
                        observer.complete();
                    }
                    else {
                        observer.error(xhr.response);
                    }
                }
            };
            xhr.open('POST', url, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + _this._cookieService.get('access_token'));
            xhr.send(formData);
        });
    };
    HttpDataService.prototype.download = function (url) {
        window.open(url);
    };
    HttpDataService = HttpDataService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_authentication_client_js_1.CookieService])
    ], HttpDataService);
    return HttpDataService;
    var HttpDataService_1;
}());
exports.HttpDataService = HttpDataService;
//# sourceMappingURL=http-data.service.js.map